<template>
  <div>
    <h3>Events</h3>
    <Loading v-if="!loaded"></Loading>
    <div v-else>
      <v-list v-if="events.length >= 1">
        <FunctionEvent
          v-for="event in events"
          :key="event.id"
          :id="parseInt(event.id)"
          :type="parseInt(event.type)"
          @eventDeleted="loadEvents"
        ></FunctionEvent>
      </v-list>
      <div v-else style="text-align: center">
        <p>No events registered.</p>
      </div>
    </div>
    <hr style="margin-bottom:10px;">
    <form @submit="addEvent">
      <v-layout row style="margin: 0">
        <v-flex>
          <v-select
            label="New event"
            @change="addEvent"
            v-model="event_type"
            no-data-text="No more events available"
            :items="all_available_types"
          ></v-select>
        </v-flex>
        <v-flex xs2 style="padding-top: 20px">
          <v-btn type="submit" text><i class="fal fa-save"></i></v-btn>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
import FunctionEvent from "./FunctionEvent";
import { Functions } from "../../logic/Functions";
import { Notifications } from "../../notification";

export default {
  props: {
    function_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      events: [],
      all_types: Functions.event_types,

      event_type: "",

      loaded: false
    };
  },
  computed: {
    all_available_types() {
      var temp = [];
      this.all_types.forEach(
        function (type) {
          if (
            this.events.filter((e) => parseInt(e.type) === type.value)
              .length === 0
          ) {
            temp.push(type);
          }
        }.bind(this)
      );
      return temp;
    },
  },
  mounted() {
    this.loadEvents();
  },
  methods: {
    async loadEvents() {
      var response = await Functions.loadEvents(this.function_id);
      this.loaded = true;
      if (response.status === 200) {
        this.events = response.body;
      } else {
        this.events = [];
      }
    },
    async addEvent(e) {
      e.preventDefault();
      if (this.event_type === "") {
        Notifications.show("Please select an event type.");
      } else {
        var response = await Functions.registerEvent(
          this.function_id,
          this.event_type
        );
        if (response.status === 200) {
          this.loadEvents();
          this.event_type = "";
          Notifications.show("The event has been registered to this function.");
        } else {
          Notifications.show(response.message);
        }
      }
    },
  },
  components: {
    FunctionEvent,
  },
};
</script>

<style>
</style>